import { axios } from "../../api";

export default {
    state: {
        getListHistory: [],
    },
    getters: {
        getListHistory: (state) => state.getListHistory,
    },
    actions: {
        GET_LIST_HISTORY({ commit }) {
            axios
                .get("/orderHistory")
                .then((res) => {
                    commit("GET_LIST_HISTORY", res.data);
                })
                .catch((err) => console.log(err));
        },
    },
    mutations: {
        GET_LIST_HISTORY(state, payload) {
            state.getListHistory = payload;
        },
    },
};
